import http from '@core/fetch'

export default {
  // 上传相册
  saveHotelPhotoInfo: body =>
    http.post('/p/wedding/index.php/admin/APIHotelMerchant/hotelPhotoInfo', {
      body
    }),

  // 相册排序
  savePhotoSortInfo: body =>
    http.post('/p/wedding/index.php/admin/APIHotelMerchant/hotelPhotoWeight', {
      body
    }),

  // 获取酒店相册类型
  photoAlbumScene: () =>
    http.get('/hms/hljHotel/appApi/admin/hotel/photoAlbumScene'),

  // 相册模块通过情况
  getAlbumStatus: () =>
    http('/p/wedding/index.php/admin/APIHotelMerchant/hotelPhotoDelStatus'),

  // 获取相册信息
  getHotelPhotoInfo: param =>
    http(
      '/p/wedding/index.php/admin/APIHotelMerchant/hotelPhotoInfo?scene=' +
        param
    ),

  // 获取审核通过的图片
  getAlbumPassPhotos: param =>
    http(
      '/p/wedding/index.php/admin/APIHotelMerchant/hotelSuccessPhoto?type=' +
        param
    ),

  // 上传酒店封面
  saveHotelCover: body =>
    http.post('/p/wedding/index.php/admin/APIHotelMerchant/changeHotelCover', {
      body
    }),

  // 获取酒店封面
  getHotelCover: () =>
    http('/p/wedding/index.php/admin/APIHotelMerchant/hotelCoverV2')
}
